import script from "./sw-item-parts-label.vue?vue&type=script&setup=true&lang=js"
export * from "./sw-item-parts-label.vue?vue&type=script&setup=true&lang=js"

import "./sw-item-parts-label.vue?vue&type=style&index=0&id=5e451903&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e451903"]])

export default __exports__